__turbopack_context__.v({
  "confirmBtn": "GeoSelector-module__UE880a__confirmBtn",
  "content": "GeoSelector-module__UE880a__content",
  "form": "GeoSelector-module__UE880a__form",
  "geoStatus": "GeoSelector-module__UE880a__geoStatus",
  "header": "GeoSelector-module__UE880a__header",
  "label": "GeoSelector-module__UE880a__label",
  "select": "GeoSelector-module__UE880a__select",
  "trigger": "GeoSelector-module__UE880a__trigger",
});
